import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TableSorter from "../common/components/TableSorter";
import DataService from "../common/services/dataService";
import { Typography } from "@mui/material";
import TablePagination from "../common/components/Pagination";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";


const useStyles = {
  tableHeaders: {
    paddingLeft: "16px",
    width: "7%",
    height: "56px"
  },
  tableCells: {
    fontWeight: "400",
    fontSize: "0.875rem",
    lineHeight: "1.57",
    letterSpacing: "0.00714em",
  },
  dropdownCells: {
    width: "100%",

  },
};


function StudyValidations() {
  const [studies, setStudies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState("runthrough_date_desc");
  const [filterNameSearch, setFilterNameSearch] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filterEnv, setFilterEnv] = useState("");
  const [filterRegion, setFilterRegion] = useState("");
  const [filterResult, setFilterResult] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [isPressed, setIsPressed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  //put in try catch
  //check async await
  useEffect(() => {
    const fetchStudies = async () => {
      try {
        console.log("calling API with orderBy:", orderBy);
        const res = await DataService.getStudyRunThroughs(orderBy);
        console.log("calling API with orderBy:", orderBy);
        const studiesData = res?.data?.data;


        if (Array.isArray(studiesData)) {
          setStudies(studiesData);
        } else {
          console.error("Expected an array at res.data.data, got:", studiesData);
          studiesData([]);
        }
      } catch (err) {
        console.error("Failed to fetch studies:", err);
        studiesData([]);
      }
    };
    fetchStudies();
  }, [orderBy]);


  const filteredForDropdowns = studies.filter((study) => {
    const matchesNameSearch = filterNameSearch ? (study.name?.toLowerCase().includes(filterNameSearch.toLowerCase()) || study.study_id?.toString().includes(filterNameSearch)) : true;
    const matchesDate = filterDate ? new Date(study.processed_datetime).toLocaleDateString("en-GB") === filterDate : true;
    const matchesEnv = filterEnv ? study.device === filterEnv : true;
    const matchesRegion = filterRegion ? study.region === filterRegion : true;
    const matchesresult = filterResult ? (study.complete ? "Pass" : "Fail") === filterResult : true;

    return matchesNameSearch && matchesDate && matchesEnv && matchesRegion && matchesresult;
  });

  const dates = [...new Set(filteredForDropdowns.map((s) => new Date(s.processed_datetime)).sort((a, b) => b - a).map((date) => date.toLocaleDateString("en-GB")))];
  const environments = [...new Set(filteredForDropdowns.map((s) => s.device))];
  const regions = [...new Set(filteredForDropdowns.map((s) => s.region))];
  const results = [...new Set(filteredForDropdowns.map((s) => s.complete ? "Pass" : "Fail"))];


  const handleSortChange = (columnLabel) => {
    console.log("handleSortChange called with:", columnLabel);
    const columnMap = {
      "Study name": "study_name",
      "Id": "study_id",
      "Date": "runthrough_date",
    };

    const sortKey = columnMap[columnLabel];
    if (!sortKey) {
      console.warn("Unknown column:", columnLabel);
      return;
    };

    const isCurrentlyAsc = orderBy === sortKey;
    const isCurrentlyDesc = orderBy === `${sortKey}_desc`;

    let newOrderBy;
    if (isCurrentlyAsc) {
      newOrderBy = `${sortKey}_desc`;
    } else if (isCurrentlyDesc) {
      newOrderBy = sortKey; // toggle back to asc
    } else {
      newOrderBy = sortKey; // defaults to asc
    };

    console.log("newOrderBy:", newOrderBy);
    setOrderBy(newOrderBy);
    console.log("Clicked column label:", columnLabel);
    console.log("Mapped to sortKey:", sortKey);
  };

  const paginatedStudies = filteredForDropdowns.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleSearchChange = (value) => {
    setFilterNameSearch(value);
    setCurrentPage(1);
  }

  const handlePageChange = (newPage) => {
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const btnStyle = {
    background: isHovered ? "#009FB5" : "#00BADB",
    width: "65px",
    height: "55px",
    borderRadius: "10%",
    border: "none",
    marginLeft: "4px",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.2s ease",
    transform: isPressed ? "scale(0.95)" : "scale(1)",
  };


  return (
    <Paper elevation={0}>
      
      <div 
        style={{
          display: "flex",
          padding: 16,
          justifyContent: "space-between",
        }}
      >        
        <TextField 
          style={{ zIndex: 0 }}
          autoFocus
          onChange={(e) => handleSearchChange(e.target.value)}
          value={filterNameSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          id="outlined-basic"
          label="Search study validations..."
          variant="outlined"
        />
        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Tooltip title="Filter studies">
            <IconButton
              onClick={() => setShowFilter(!showFilter)}
              aria-label="filter results"
              component="span"
            >
              <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
            </IconButton>
          </Tooltip>
        </div>

      </div>
      {showFilter && (
        <div style={{ display: "flex", gap: 16, padding: "0 16px 16px" }}>
          <TextField style={useStyles.dropdownCells} select label="Date" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
            <option value="">All</option>
            {dates.map((date) => (
              <option key={date} value={date}>{date}</option>
            ))}
          </TextField>
          <TextField style={useStyles.dropdownCells} select label="Environment" value={filterEnv} onChange={(e) => setFilterEnv(e.target.value)} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
            <option value="">All</option>
            {environments.map((env) => (
              <option key={env} value={env}>{env}</option>
            ))}
          </TextField>
          <TextField style={useStyles.dropdownCells} select label="Region" value={filterRegion} onChange={(e) => setFilterRegion(e.target.value)} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
            <option value="">All</option>
            {regions.map((region) => (
              <option key={region} value={region}>{region}</option>
            ))}
          </TextField>
          <TextField style={useStyles.dropdownCells} select label="Result" value={filterResult} onChange={(e) => setFilterResult(e.target.value)} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
            <option value="">All</option>
            {results.map((res) => (
              <option key={res} value={res}>{res}</option>
            ))}
          </TextField>
        </div>
      )}



      <div style={{ marginRight: 8, width: "100%" }}>


        <TablePagination
          numberOfPages={Math.ceil(filteredForDropdowns.length / rowsPerPage)}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) => handleRowsPerPageChange(parseInt(event.target.value, 10))} />

      </div>

      <table className="table">

        <thead>
          <tr>
            {["Study name", "Id", "Date", "Environment", "Region", "Result", "Video"].map((heading, index) => {
              const isSortable = ["Study name", "Id", "Date"].includes(heading);
              return (
                <th key={heading}
                  style={{ ...useStyles.tableHeaders, paddingLeft: index === 0 ? "32px" : useStyles.tableHeaders.paddingLeft, width: index === 0 ? "15%" : useStyles.tableHeaders.width, boxShadow: index === 0 ? "rgb(255, 255, 255) 16px 0px 0px inset" : useStyles.tableHeaders.boxShadow }}
                >
                  <h4 style={{ display: "inline" }}>{heading}</h4>
                  {isSortable && (
                    <TableSorter
                      name={heading}
                      handleSortChange={handleSortChange}
                      currentOrderBy={orderBy}
                      rawSort={false} />
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>

          {paginatedStudies.map((study, index) => (
            <tr key={index}>
              <td style={{ paddingLeft: "32px" }}>
                <span
                  onClick={() => {
                    const latestValidation = study.id;
                    if (latestValidation) {
                      window.open(`/study/${study.study_id}/validations/${latestValidation}`);
                    } else {
                      console.warn("No validations available");
                    }
                  }}
                  style={{
                    color: "#000",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: "500",
                  }}
                >
                  {study.name}
                </span>
              </td>
              <td style={useStyles.tableHeaders}>
                <Typography
                  title={study.study_id}
                  style={useStyles.tableCells}
                >
                  {study.study_id}
                </Typography>
              </td>
              <td style={useStyles.tableHeaders}>
                <Typography
                  title={study.processed_datetime}
                  style={useStyles.tableCells}
                >
                  {new Date(study.processed_datetime).toLocaleDateString("en-GB")}
                </Typography>
              </td>
              <td style={useStyles.tableHeaders}>
                <Typography
                  component={"span"}
                  title={study.user_name}
                  style={{ color: "#000" }}
                >
                  {study.device}
                </Typography>
              </td>
              <td style={useStyles.tableHeaders}>
                <Typography
                  component={"span"}
                  title={study.date}
                  style={{ color: "#000" }}
                >
                  {study.region}
                </Typography>
              </td>
              <td style={useStyles.tableHeaders}>
                <Typography
                  component={"span"}
                  title={study.success ? "Success" : "Failure"}
                  style={{ color: "#000" }}
                >
                  {study.complete ? "Pass" : "Fail"}
                </Typography>
              </td>
              <td style={useStyles.tableHeaders}>
                {!study.complete || !study.video_url ? (
                  "No video"
                ) : (
                  <span
                    style={{
                      color: "1976d2",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}
                    onClick={() => {
                      setVideoUrl(study.video_url);
                      setIsModalOpen(true);
                    }}
                  >
                    Play video
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {isModalOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          justifyContent: "center",
          alighItems: "center",
          zIndex: 1000,
        }}
          onClick={() => setIsModalOpen(false)}
        >
          <div style={{ position: "relative", width: "80%", maxWidth: "800px", top: "6rem" }}
            onClick={(e) => e.stopPropagation()}
          >
            <video controls autoPlay style={{ width: "100%", borderRadius: "8px" }}>
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag
            </video>
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                background: "white",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
              }}>
              x
            </button>
          </div>
        </div>
      )}
    </Paper>
  );
}

StudyValidations.propTypes = {

};

export default StudyValidations;